import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AiAppDataModelState } from '../reducers/aiapplicationdatamodel.reducer';

export const aiAppDataModelState: any = createFeatureSelector<AiAppDataModelState>('aiAppDataModel');

export const acceptSuccessData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.acceptSuccessData;
});

export const acceptFailureData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.acceptFailureData;
});

export const rejectSuccessData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.rejectSuccessData;
});

export const rejectFailureData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.rejectFailureData;
});

export const aiDMSuccData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.aiDMSuccData;
});

export const aiDMFailData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.aiDMFailData;
});

export const generateModelForTablePromptSuccData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.generateModelForTablePromptSuccData;
});

export const generateModelForTablePromptFailData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.generateModelForTablePromptFailData;
});

export const generateModelForFieldPromptSuccData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.generateModelForFieldPromptSuccData;
});

export const generateModelForFieldPromptFailData = createSelector(aiAppDataModelState, (state: any) => {
  return state?.generateModelForFieldPromptFailData;
});
